<div class="feedback-dialog-container">
  @if (hasSubmittedSuccessfully) {
    <div class="submitted-info-container">
      <div>
        <h2>Takk for din tilbakemelding</h2>
        <p>Det hjelper oss å gjøre Diego bedre!</p>
      </div>
      <img alt="Tommel opp" [src]="(selectedTheme$ | async).thumbs_up_illustration" />
      <app-ice-button color="outlined" testId="close-feedback-dialog-button" (click)="onClose()">Lukk</app-ice-button>
    </div>
  } @else {
    <form class="feedback-form" [formGroup]="feedbackForm">
      <h1>Tilbakemelding</h1>
      <p>Gi oss på Diego-teamet tilbakemelding slik at vi kan gjøre Diego bedre for deg!</p>
      <div class="error-info-box color-exemption">
        Skal du gi beskjed om en feil i Diego?
        <a class="error-feedback-link" data-testid="error-feedback-link" (click)="openErrorDialog()">Meld fra om feil her</a>
      </div>
      <h2>Hvordan synes du Diego fungerer?</h2>
      <app-diego-rating formControlName="rating" [diegoRatings]="diegoRatings" />
      <app-ice-textarea
        formControlName="feedback"
        label="Din tilbakemelding"
        longHelpText="Hva synes du fungerer bra og er det noe som kunne vært bedre?"
        ngDefaultControl
        testId="feedback-input"
      />
      <div class="buttons-container">
        <app-ice-button color="outlined" testId="abort-feedback-dialog-button" (click)="onClose()">Avbryt</app-ice-button>
        <app-ice-button
          color="secondary"
          testId="submit-feedback-button"
          type="submit"
          [disabled]="feedbackForm.invalid"
          [isLoading]="isLoading"
          (click)="onSubmit()"
        >
          Gi tilbakemelding
        </app-ice-button>
      </div>
    </form>
  }
</div>
